import {Box, Typography} from '@mui/material';
import React from 'react';

import {useMediaQueries} from 'presentation/pages/private/hooks';
import {SectionContainerProps} from './types';

import {ActionButton, HeaderAppointmentsContainer} from './styles';
import {useHostName} from 'presentation/hooks';

export function SectionContainer({
	title,
	children,
	showTitle,
	handleAction,
	actionText,
	customTitleColor,
	titleMarginTop,
	titleMarginBottom,
	...boxProps
}: SectionContainerProps) {
	const {isLaptop} = useMediaQueries();
	const showActionButton = Boolean(handleAction && actionText);
	const {isNotredameSaude} = useHostName();
	let titleColor = 'text.secondary';

	if (customTitleColor) {
		titleColor = customTitleColor;
	} else if (isNotredameSaude) {
		titleColor = 'text.primary';
	}

	return (
		<Box {...boxProps}>
			{isLaptop || showTitle ? (
				<HeaderAppointmentsContainer $showActionButton={showActionButton}>
					<Typography
						marginBottom={titleMarginBottom ?? 2}
						marginTop={titleMarginTop ?? 2}
						variant={'body1'}
						color={titleColor}
						fontSize={isNotredameSaude ? '1rem' : '0.875rem'}
						fontWeight={600}>
						{title}
					</Typography>
					{showActionButton ? (
						<ActionButton variant="text" size="small" onClick={handleAction}>
							{actionText}
						</ActionButton>
					) : null}
				</HeaderAppointmentsContainer>
			) : null}
			{children}
		</Box>
	);
}
